import React, {Component,Fragment} from 'react';
import loadable from '@loadable/component'

import { Route, Switch,withRouter} from "react-router-dom";
import * as ROUTES from "../constants/routePaths";


/*import HomePage from '../pages/homePage';
import EvaluationPage from "../pages/evaluationPage";
import EditAppointmentValuePage from "../pages/editAppointmentValuesPage";
import AppointmentUpdatedPage from "../pages/appointmentUpdatedPage";
import AppointmentEditedPage from "../pages/appointmentEditedPage";
import ServiceAppointmentTimePage from "../pages/serviceAppointmentTimePage";
import AppointmentSelectPage from "../pages/appointmentSelectPage";
import ServiceAppointmentNotePage from "../pages/serviceAppointmentNotePage";
import ServiceAppointmentCompletedPage from "../pages/serviceAppointmentCompletedPage";
import ServiceAppointmentConfirmationPage from "../pages/serviceAppointmentConfirmationPage";
import ServiceAppointmentUserInfoPage from "../pages/serviceAppointmentUserInfoPage";
import ServiceAppointmentSucceedPage from "../pages/serviceAppointmentSucceedPage";
import StartButtonPageV2 from "../pages/startButtonPageV2";
 */

import {connect} from "react-redux";
import queryString from "querystring";
import {
    TransitionGroup,
    CSSTransition
} from "react-transition-group";


var HomePage =    loadable(() => import('../pages/homePage'));
var EvaluationPage =   loadable(() => import("../pages/evaluationPage"));
var EditAppointmentValuePage =   loadable(() => import("../pages/editAppointmentValuesPage"));
var AppointmentUpdatedPage =   loadable(() => import("../pages/appointmentUpdatedPage"));
var AppointmentEditedPage =   loadable(() => import("../pages/appointmentEditedPage"));
var ServiceAppointmentTimePage =   loadable(() => import("../pages/serviceAppointmentTimePage"));
var ServiceAppointmentServicePage =   loadable(() => import("../pages/serviceAppointmentServicePage"));
var AppointmentSelectPage =   loadable(() => import("../pages/appointmentSelectPage"));
var ServiceAppointmentNotePage =   loadable(() => import("../pages/serviceAppointmentNotePage"));
var ServiceAppointmentCompletedPage =   loadable(() => import("../pages/serviceAppointmentCompletedPage"));
var ServiceAppointmentConfirmationPage =   loadable(() => import("../pages/serviceAppointmentConfirmationPage"));
var ServiceAppointmentUserInfoPage =  loadable(() => import("../pages/serviceAppointmentUserInfoPage"));
var ServiceAppointmentSucceedPage =   loadable(() => import("../pages/serviceAppointmentSucceedPage"));
var StartButtonPageV2 =   loadable(() => import("../pages/startButtonPageV2"));

var ServiceAppointmentTypePage = loadable(()=> import("../pages/serviceAppointmentTypePage"));

class RoutesComponent extends Component {


    state = {
        config:{
            service:true
        }
    }
    changeRouteManually = (route) =>{

        let params = route.location.search.split("&").map(x=>{return {

        }});
        //console.log(params);
        switch (route) {

        }

    }

    componentDidMount() {

        let rootDiv = document.getElementById("vitra-appointment");
        if(rootDiv){
            let config = rootDiv.getAttribute("data-config");
            if(config){
                console.log("config",JSON.parse(config))
                this.setState({
                    config:JSON.parse(config)
                },()=>{
                    this.forceUpdate()
                })
            }
        }
    }


    render() {

        return (
            <div className={Object.keys(ROUTES).findIndex(x=>ROUTES[x] === this.props.location.pathname) !==-1 ? "main-route":""}>
                <TransitionGroup>
                    <CSSTransition
                        key={1}
                        classNames="fade"
                        timeout={300}
                    >

                {/*{
                    this.changeRouteManually(this.props.history)
                }*/}
                <Switch>
                    <Route exact path={ROUTES.HOME} component={HomePage}/>

                    <Route exact path={ROUTES.SELECT_PAGE} component={AppointmentSelectPage}/>,
                    
                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_TYPE} component={ ServiceAppointmentTypePage}/>,

                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_TIME} component={ ServiceAppointmentServicePage}/>,
                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_SERVICE} component={ServiceAppointmentTimePage}/>,
                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_NOTE} component={ServiceAppointmentNotePage}/>,
                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_USER_INFO} component={ServiceAppointmentUserInfoPage}/>,
                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_COMPLETED} component={ServiceAppointmentCompletedPage}/>,
                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_CONFIRMATION} component={ServiceAppointmentConfirmationPage}/>,
                    <Route exact path={ROUTES.SERVICE_APPOINTMENT_SUCCESS} component={ServiceAppointmentSucceedPage}/>

                    <Route exact path={ROUTES.EVALUATION} component={EvaluationPage}/>
                    <Route exact path={ROUTES.APPOINTMENT_UPDATED} component={AppointmentUpdatedPage}/>
                    <Route exact path={ROUTES.APPOINTMENT_EDITED} component={AppointmentEditedPage}/>
                    <Route exact path={ROUTES.EDIT_APPOINTMENT} component={EditAppointmentValuePage}/>
                    <Route exact path={"*"} component={StartButtonPageV2}/>
                </Switch>
                    </CSSTransition>
                </TransitionGroup>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({

});

export default withRouter(connect(mapStateToProps)(RoutesComponent));